import React, { useState } from 'react'
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AccountOrders from './AccountOrders'
import InputSalesInvoices from './InputSalesInvoices'
import InputSalesInvoiceProductReview from './InputSalesInvoiceProductReview'
import InvoiceInformationReview from './InvoiceInformationReview'


const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({

  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

}));

function SalesInvoiceInputMain(props) {
 // const classes = useStyles();
  const theme = useTheme();

  const [openInputDialog, setOpenInputDialog] = React.useState(false);
  const [openProductReviewDialog, setOpenProductReviewDialog] = React.useState(false);
  const [openInvoiceInformationReviewDialog, setOpenInvoiceInformationReviewDialog] = React.useState(false);
  const [selectedAccount, setSelectedAccount] = useState()
  const [selectedSalesOrder, setSelectedSalesOrder] = useState()

  const openDialogInputHandleClick = (salesOrder) => {

    setOpenInputDialog(true);
    setSelectedSalesOrder(salesOrder)

  };
  const closeDialogInputDialog = () => {
    setOpenInputDialog(false);
  };
  const closeThenOpenInputDialog = () => {
    setOpenInputDialog(false);
    setTimeout(function () {
      setOpenInputDialog(true);
    }, 1000);
  }
  const openProductReviewDialogHandleClick = () => {

    setOpenProductReviewDialog(true);

  };
  const closeProductReviewDialogHandleClick = () => {
    setOpenProductReviewDialog(false);
  };

  const openInvoiceInformationReviewDialogHandleClick = () => {

    setOpenInvoiceInformationReviewDialog(true);

  };
  const closeInvoiceInformationReviewDialogHandleClick = () => {
    setOpenInvoiceInformationReviewDialog(false);
  };

  const closeAllDialog = () => {
    setOpenInputDialog(false);
    setOpenProductReviewDialog(false);
    setOpenInvoiceInformationReviewDialog(false);
  }
  return (
    <div>

      <AccountOrders handleDrawerToggle={props.handleDrawerToggle} openDialogInputHandleClick={openDialogInputHandleClick} transactiUserTypeCode={props.transactiUserTypeCode} />
      {openInputDialog ? <InputSalesInvoices selectedSalesOrder={selectedSalesOrder} selectedAccount={selectedAccount} closeThenOpenInputDialog={closeThenOpenInputDialog} closeDialogInputDialog={closeDialogInputDialog} openInputDialog={openInputDialog} openProductReviewDialogHandleClick={openProductReviewDialogHandleClick} /> : ""}

      <InputSalesInvoiceProductReview selectedSalesOrder={selectedSalesOrder} selectedAccount={selectedAccount} closeProductReviewDialogHandleClick={closeProductReviewDialogHandleClick} openProductReviewDialog={openProductReviewDialog} openInvoiceInformationReviewDialogHandleClick={openInvoiceInformationReviewDialogHandleClick} />
      <InvoiceInformationReview selectedSalesOrder={selectedSalesOrder} closeInvoiceInformationReviewDialogHandleClick={closeInvoiceInformationReviewDialogHandleClick} openInvoiceInformationReviewDialog={openInvoiceInformationReviewDialog} closeAllDialog={closeAllDialog} selectedAccount={selectedAccount} />

    </div>
  )
}

export default SalesInvoiceInputMain